import React from "react";
import ContentManagement from "../ContentManagement/ContentManagement";
import newsManagementService from "../../services/DevotionalNewsManagement";
import { CONTENT_TYPES_CONFIG } from "../../config/App.config";

const DevotionalNews = () => {
  return (
    <ContentManagement
      service={newsManagementService}
      pageSize={10}
      sidebarItemLayout="horizontal"
      // use the devotional news title as the slug
      getSlug="title"
      contentType={CONTENT_TYPES_CONFIG.NEWS}
    />
  );
};

export default DevotionalNews;